<template>
  <div class="gSwiperBox2">
    <swiper :options="swiperOption" :ref="name">
      <swiper-slide v-for="(item, index) in list" :key="'gSwiperCommon-' + index">
        <div class="swiperBox-content">
          <div class="sbc-title">{{item.name}}</div>
          <div class="sbc-info">
            <div class="sbc-logo">
              <img :src="item.logo" v-if="item.logo" />
              <img src="@assets/img/empty.png" v-else />
            </div>
            <div class="sbc-content">{{item.summary}}</div>
          </div>
        </div>
        <img :src="item.cover" v-if="item.cover" class="swiper-cover" />
        <img src="@assets/img/empty.png" v-else class="swiper-cover" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "gSwiperCommon",
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        spaceBetween: 0,
        loop: true,
        // autoplay: true,
        pagination: {
          clickable: true
        }
      },
      name: ""
    };
  },
  computed: {
    swiper() {
      return this.$refs[this.name].swiper;
    }
  },
  created() {
    this.name = `mySwiper-${Math.random()}`;
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   this.swiper.slideTo(3, 1000, false);
  },
  methods: {}
};
</script>

<style lang="scss">
.gSwiperBox2 {
  width: 100%;
  background-color: #ddd;
  .swiper-slide {
    position: relative;
    img {
      width: 100%;
    }
    .swiper-cover {
      filter: blur(5px);
      position: relative;
    }
  }
  .swiperBox-content {
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 25px;
    color: #fff;
  }
  .sbc {
    &-title {
      font-size: 18px;
      font-weight: bold;
      color: #fffeff;
      margin-bottom: 15px;
    }
    &-info {
      display: flex;
    }
    &-logo {
      width: 62px;
      height: 62px;
      margin-right: 8px;
      align-items: center;
      position: relative;
      background: #fff;
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }
    }
    &-content {
      font-size: 13px;
      color: #fff;
      flex: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
}
.gSwiperBox2 .swiper-container {
  font-size: 0;
}
.gSwiperBox2 .swiper-pagination {
  font-size: 0;
  display: flex;
  justify-content: flex-end;
  padding-right: 18px;
  bottom: 22px;
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    border-radius: 0;
    background-color: #ddd;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background-color: #ed6e02;
    opacity: 1;
  }
}
</style>